import { NSMenuActionProps } from "namirasoft-site-react";
import { NotificationSenderRoutes } from "./NotificationSenderRoutes";
import { SubscriberRow } from "namirasoft-notification-sender";

export class NotificationSenderMenus
{
	static verify(getIDs: () => string[], getRows: (() => SubscriberRow[])): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Verify",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let rows = getRows();
					if (rows)
						if (rows.length > 0)
							return !rows[0].verified;
				}
				return false;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = NotificationSenderRoutes.SubscriberVerify(id);
				},
				showLoading: false
			}
		}
	}
	static send(getIDs: () => string[]): NSMenuActionProps
	{
		return {
			id: "2",
			menu_item: "Send",
			isActive: () => getIDs().length === 1,
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					window.location.href = NotificationSenderRoutes.Send(id);
				},
				showLoading: false
			}
		}
	}
}